import { render, staticRenderFns } from "./expendable-faq.vue?vue&type=template&id=e5bea80c&"
import script from "./expendable-faq.vue?vue&type=script&lang=js&"
export * from "./expendable-faq.vue?vue&type=script&lang=js&"
import style0 from "./expendable-faq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports